import { Splide, Options as CarouselOption } from "@splidejs/splide";

export default class NoticeCarousel {
    carouselElement: HTMLElement;

    carousel: Splide;
    options: CarouselOption;
    isPaginationUpdated: boolean = false;

    constructor(elemId: string, carouselOptions: string) {
        const widgetContainer = document.getElementById(elemId);
        this.carouselElement = widgetContainer.querySelector(".notice-carousel");
        this.options = JSON.parse(carouselOptions);

        this.initialiseCarousel();
    }

    private initialiseCarousel(): void {
        this.carousel = new Splide(this.carouselElement, {
            type: 'loop',
            autoplay: this.options.autoplay,
            interval: this.options.autoplayInterval,
            pauseOnHover: this.options.pauseOnHover,
            perPage: 1,
            perMove: 1,
            arrows: this.options.displayArrows,
            pagination: this.options.displayIndicators,
            drag: this.options.draggable,
            lazyLoad: 'nearby',
            focus: 'center',
        });

        this.carousel.mount();
    }
}
   